import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../../../shared/shared.module';
import { AdminAccess } from '../../../../shared/accessAdmin';
import { FlexLayoutModule } from '@angular/flex-layout';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';
import { WaterBodiesFormComponent } from './water-bodies-form.component';
import { WaterBodiesFormRoutingModule } from './water-bodies-form-routing.module';
import { WaterBodiesFormResolve } from './water-bodies-form.resolve';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    FlexLayoutModule,
    WaterBodiesFormRoutingModule,
  ],
  declarations: [WaterBodiesFormComponent],
  exports: [WaterBodiesFormComponent],
  providers: [AdminAccess, WaterBodiesFormResolve],
})
export class WaterBodiesFormModule {}
